module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8IUM8"))).then(() => module.bundle.root('hEqeo'));